const LOAD_WEBSOCKET_TOKEN = 'STREAM/LOAD_WEBSOCKET_TOKEN';
const CLEANUP_WEBSOCKETS = 'STREAM/CLEANUP_WEBSOCKETS';

export { LOAD_WEBSOCKET_TOKEN, CLEANUP_WEBSOCKETS };
